import { createAction, props } from '@ngrx/store'

export const BUTTON_CLICK = '[PanelControl] Ha cambiado el estado del boton'

export const REST_PANEL_CONTROL_STATE = '[PanelControl] Se reinicia el estado del panel de control.'

export const buttonClick = createAction(BUTTON_CLICK, props<{ action: { type: string } }>())

export const resetPanelControlState = createAction(REST_PANEL_CONTROL_STATE)
